import React from 'react';
import PropTypes from 'prop-types';
import { connectToModel, bindToPath } from 'client/data/luckdragon/redux/react-binding';
import { CmsEntities, bindToContent } from 'client/data/models/cms';
import { PageModel } from 'client/data/models/page';
import { U_DRAGS_LEADERBOARD_CONTENT_PATH } from 'site-modules/editorial/constants/u-drags-leaderboard';
import { LeaderboardInfographic } from 'site-modules/editorial/components/leaderboard-infographic/leaderboard-infographic';

export function UdragsLeaderboardUI({ content, pathname, isWidget }) {
  if (!content) {
    return null;
  }

  return (
    <LeaderboardInfographic
      content={content}
      pathname={pathname}
      widgetName="u-drags-leaderboard"
      title="U-Drags Leaderboard"
      titleColorClassName="text-primary"
      barsMap={[
        { label: 'Quarter mile', key: 'quarterMile' },
        { label: 'Finishing time', key: 'time' },
      ]}
      stepValue={10}
      maxValue={60}
      chartValueMeasure="s"
      isWidget={isWidget}
    />
  );
}

UdragsLeaderboardUI.propTypes = {
  content: CmsEntities.Content,
  pathname: PropTypes.string,
  isWidget: PropTypes.bool,
};

UdragsLeaderboardUI.defaultProps = {
  content: null,
  pathname: null,
  isWidget: false,
};

export const UdragsLeaderboard = connectToModel(UdragsLeaderboardUI, {
  content: bindToContent(U_DRAGS_LEADERBOARD_CONTENT_PATH),
  pathname: bindToPath('location.pathname', PageModel),
});
